export const actions = {
    SHOW: 'SHOW',
    HIDE: 'HIDE',
    SHOW_POSTCODE_LAYER: 'SHOW_POSTCODE_LAYER',
    HIDE_POSTCODE_LAYER: 'HIDE_POSTCODE_LAYER',
    SHOW_PRODUCT_LAYER: 'SHOW_PRODUCT_LAYER',
    HIDE_PRODUCT_LAYER: 'HIDE_PRODUCT_LAYER',
    SHOW_ORDER_FORM_LAYER: 'SHOW_ORDER_FORM_LAYER',
    HIDE_ORDER_FORM_LAYER: 'HIDE_ORDER_FORM_LAYER',
    SHOW_ORDER_STATUS_LAYER: 'SHOW_ORDER_STATUS_LAYER',
    HIDE_ORDER_STATUS_LAYER: 'HIDE_ORDER_STATUS_LAYER',
    SHOW_SHIPPING_ADDRESS_FORM_LAYER: 'SHOW_SHIPPING_ADDRESS_FORM_LAYER',
    HIDE_SHIPPING_ADDRESS_FORM_LAYER: 'HIDE_SHIPPING_ADDRESS_FORM_LAYER',
    SET_QUANTITY: 'SET_QUANTITY',
    RESET_QUANTITY: 'RESET_QUANTITY',
    SET_CART: 'SET_CART',
    UNSET_CART: 'UNSET_CART',
    SET_FITTING_OPTIONS: 'SET_FITTING_OPTIONS',
    UNSET_FITTING_OPTIONS: 'UNSET_FITTING_OPTIONS',
    SET_SHIPPING_OPTIONS: 'SET_SHIPPING_OPTIONS',
    UNSET_SHIPPING_OPTIONS: 'UNSET_SHIPPING_OPTIONS',
    SHOW_ITEM_PRICE_DETAILS: 'SHOW_ITEM_PRICE_DETAILS',
    HIDE_ITEM_PRICE_DETAILS: 'HIDE_ITEM_PRICE_DETAILS',
    SHOW_SHIPPING_PRICE_DETAILS: 'SHOW_SHIPPING_PRICE_DETAILS',
    HIDE_SHIPPING_PRICE_DETAILS: 'HIDE_SHIPPING_PRICE_DETAILS',
    SET_ORDER: 'SET_ORDER',
    UNSET_ORDER: 'UNSET_ORDER',
    SET_ERROR_MESSAGE: 'SET_ERROR_MESSAGE',
    UNSET_ERROR_MESSAGE: 'UNSET_ERROR_MESSAGE',
    SET_FITTING_PRICE_IN_DETAIL_MODE: 'SET_FITTING_PRICE_IN_DETAIL_MODE',
    UNSET_FITTING_PRICE_IN_DETAIL_MODE: 'UNSET_FITTING_PRICE_IN_DETAIL_MODE',
    SET_SELECTED_FITTING_OPTION: 'SET_SELECTED_FITTING_OPTION',
    UNSET_SELECTED_FITTING_OPTION: 'UNSET_SELECTED_FITTING_OPTION',
    SET_WITHOUT_FITTING_OPTION: 'SET_WITHOUT_FITTING_OPTION',
    UNSET_WITHOUT_FITTING_OPTION: 'UNSET_WITHOUT_FITTING_OPTION',
    SHOW_NO_FITTING_SHIPPING_ADDRESS_SUMMARY: 'SHOW_NO_FITTING_SHIPPING_ADDRESS_SUMMARY',
    HIDE_NO_FITTING_SHIPPING_ADDRESS_SUMMARY: 'HIDE_NO_FITTING_SHIPPING_ADDRESS_SUMMARY',
    SHOW_NO_FITTING_SHIPPING_ADDRESS_INPUT: 'SHOW_NO_FITTING_SHIPPING_ADDRESS_INPUT',
    SET_PAYMENT_STATUS: 'SET_PAYMENT_STATUS',
    UNSET_PAYMENT_STATUS: 'UNSET_PAYMENT_STATUS',
    SET_TIMER_INTERVAL_ID: 'SET_TIMER_INTERVAL_ID',
    UNSET_TIMER_INTERVAL_ID: 'UNSET_TIMER_INTERVAL_ID',
    ADD_FITTING_SERVICE: 'ADD_FITTING_SERVICE',
    REMOVE_FITTING_SERVICE: 'REMOVE_FITTING_SERVICE',
    CLEAR_FITTING_SERVICE: 'CLEAR_FITTING_SERVICE',
};
